import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const ResetPasswordCompletePage = lazy(() =>
  import('@/components/pages/ResetPasswordCompletePage').then(({ ResetPasswordCompletePage }) => ({
    default: ResetPasswordCompletePage,
  })),
);

export const ResetPasswordCompleteRoute: AppRouteConfig = {
  key: 'reset-password-complete-page',
  path: '/reset_password_complete/:locale?',
  component: ResetPasswordCompletePage,
};
